import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { applyBranding } from '@/config/branding';
import {
  isAdminPath,
  rescueAlreadyTried,
  unregisterServiceWorkers,
} from '@/lib/serviceWorker';
import '@/i18n';
import { AuthProvider } from '@/state/AuthContext';
import { ThemeProvider } from '@/state/ThemeContext';
import { ToastProvider } from '@/state/ToastContext';

import App from './App';
import './index.css';

// La paleta de src/config/branding.ts se vuelca en :root antes del primer
// render, de modo que cambiar la marca no exige recompilar Tailwind.
applyBranding();

/**
 * Rescate del panel de administracion.
 *
 * Si ESTA aplicacion (la del atleta) arranca en una direccion del panel, el
 * servidor no ha tenido nada que ver: /admin devuelve el panel correctamente.
 * Lo que ha pasado es que un service worker viejo —guardado antes de que se
 * excluyera /admin— se ha quedado con la navegacion y ha servido el index.html
 * del atleta, cuyo router no conoce esa ruta y pinta un 404.
 *
 * Se da de baja y se recarga: la segunda carga va a la red y abre el panel.
 * El candado de sessionStorage evita el bucle; si al recargar sigue cayendo
 * aqui, se renderiza y la pagina de "no encontrada" ofrece la salida a mano.
 */
const rescatando = isAdminPath(location.pathname) && !rescueAlreadyTried(location.pathname);

if (rescatando) {
  void unregisterServiceWorkers().then(() => location.reload());
}

const container = document.getElementById('root');
if (!container) throw new Error('Falta el elemento #root en index.html');

// Mientras se rescata no se pinta nada: un 404 que aparece y desaparece
// asusta mas que media decima de segundo en blanco.
if (!rescatando) {
  createRoot(container).render(
    <StrictMode>
      <BrowserRouter>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}
